module.exports = __webpack_public_path__ + "static/media/multiplekeys.304f59de.svg";